fetch("https://ipinfo.io/json")
  .then((response) => response.json())
  .then((data) => {
    if (data.country === "CA") {
      document.querySelectorAll(".js-header-currency-button").forEach((el) => {
        el.style.display = "inline-block";
      });
    } else {
      document
        .querySelector(".hide-extra-payment-methods")
        ?.classList.remove("hide-extra-payment-methods");
    }
  })
  .catch((error) => console.error("Country error:", error));

function chatButtonPosition() {
  var initGorgiasChatPromise = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener("gorgias-widget-loaded", function () {
          resolve();
        });
      });
  initGorgiasChatPromise.then(() => {
    const sticky_add_to_cart = document.querySelector(".product-sticky-form");
    if (sticky_add_to_cart) {
      const add_to_cart_main = document.querySelector(
        ".shopify-section--main-product #AddToCart"
      );
      const add_to_cart_main_bottom =
        add_to_cart_main.getBoundingClientRect().bottom;
      const chat_button = document.querySelector("#chat-button");
      if (chat_button) {
        if (add_to_cart_main_bottom <= 80) {
          chat_button.classList.add("scroll-top");
        } else {
          chat_button.classList.remove("scroll-top");
        }
      }
    }
  });
}

document.addEventListener("scroll", () => chatButtonPosition());
